'use-client';
import * as React from 'react';
import type {
  IPaginatedGalleryImperativeActions,
  IPaginatedGridGalleryProps,
} from '../../../PaginatedGridGallery.types';
import PaginatedGridGallery from '../../PaginatedGridGallery';
import skinsItemStyle from '../../../../PaginatedGridGalleryItem/viewer/style/PaginatedGridOverlaySkinItem.scss';
import skinsStyle from './style/PaginatedGridOverlaySkin.scss';

const PaginatedGridOverlaySkin: React.ForwardRefRenderFunction<
  IPaginatedGalleryImperativeActions,
  Omit<IPaginatedGridGalleryProps, 'skin'>
> = (props, ref) => {
  return (
    <PaginatedGridGallery
      {...props}
      ref={ref}
      skinsStyle={skinsStyle}
      skinsItemStyle={skinsItemStyle}
      hasPanel={true}
    />
  );
};

export default React.forwardRef(PaginatedGridOverlaySkin);
